export const API_URL = process.env.NODE_ENV === 'production' ? 'https://crudd.dev/api' : 'http://192.168.1.105:3000/api';
export const PAGE_SIZE = 50;